// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2799":"bb316c81c50a5d4c","7796":"5677ad481e2285d6","9897":"5c3c494a79788e24"}[chunkId] + ".css";
};